export { MODULE_NAME } from './rent.const';
export { store } from './store/rent.store';
